export default __webpack_public_path__ + "static/media/chocho_m.e741e8b6.jpg";